import React from 'react'
import { Experiences,ExperienceCard } from '../Components/Experiences'
import '../styles/Experience.css'
import { H2 } from '../Components/Reusable'

const Experience = () => {
  return(
    <section id='experience' className="experience">
        <H2>My Experience</H2>
        <div className="experience-wrapper">
            <div className='lineup'></div>
            {
                Experiences.map((experience)=>{
                    return(
                        <ExperienceCard {...experience}/>
                    )
                })
            }
        </div>
    </section>
  )
}
export default Experience